import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import api from '../../../api';

const VisionMission = () => {
    const { campus_slug } = useParams();
    const [data, setData] = useState({
        title: '',
        vision: '',
        mission: '',
        images: [],
        loading: true,
        error: null,
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await api.get(`/api/campus/${campus_slug}/vision-mission`);
                if (res.data.success) {
                    setData({ ...res.data.data, loading: false });
                } else {
                    setData(prev => ({ ...prev, loading: false, error: res.data.message }));
                }
            } catch (err) {
                setData(prev => ({
                    ...prev,
                    loading: false,
                    error: err.response?.data?.message || 'Network error',
                }));
            }
        };

        fetchData();
    }, [campus_slug]);

    const swiperSettings = {
        loop: true,
        spaceBetween: 10,
        slidesPerView: data.images.length < 3 ? data.images.length : 3,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        modules: [Autoplay],
        breakpoints: {
            0: { slidesPerView: 1 },
            768: { slidesPerView: 1 },
            1024: { slidesPerView: 3 },
        }
    };

    if (data.loading || data.error) {
        return <></>;
    }

    if (data.title === '' && data.vision === '' && data.mission === '' && data.images.length === 0) {
        return <></>;
    }

    return (
        <section className="parralex_section explore-full-image mb-5">
            <div className="explore-text">
                <div className="container-fluid">
                    <div className="row">
                        <div 
                            className={`d-flex align-items-center justify-content-center ${!data.vision && !data.mission ? 'col-12' : 'col-md-4'}`}
                        >
                            <h3 className="block-title mt-4 mb-4 mb-md-0 mt-md-0">{data.title}</h3>
                        </div>
                        {data.vision && data.mission && (
                            <div className="col-md-6 star-background">
                                <p>{data.vision}</p>
                                <p>{data.mission}</p>
                            </div>
                        )}
                    </div>
                    {data.images.length > 0 && (
                        <div className="row">
                            <div className="ac-overview p-0">
                                <Swiper {...swiperSettings} className="gallery-images-carousel">
                                    {data.images.map((img, idx) => (
                                        <SwiperSlide key={idx}>
                                            <div className="gallery_single_item">
                                                <img 
                                                    src={`${process.env.REACT_APP_API_URL}/public/${img}`} 
                                                    alt={`vision-mission-${idx}`} 
                                                />
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default VisionMission;